module.exports = __webpack_public_path__ + "img/9788901133362.cd26b76e.jpg";